import { RequestsChartSkeleton } from 'modules/common/components/RequestsChartSkeleton';

import { Header } from './components/Header';
import { useChainPageSkeletonStyles } from './useChainPageSkeletonStyles';

export const ChainPageSkeleton = () => {
  const { classes } = useChainPageSkeletonStyles();

  return (
    <div className={classes.root}>
      <Header />
      <RequestsChartSkeleton />
    </div>
  );
};
